import { Typography } from '@mui/material'
import { StudentThankYouScreenContent } from 'utils/constants'

// ==================== Feedback Submitted Screen ====================

export const FeedbackSubmittedScreen: React.FC = () => {
    return (
        <Typography variant='h3' sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {StudentThankYouScreenContent.submittedMessage}
        </Typography>
    )
}
